import React, { Component } from 'react';

class noMatch extends Component {

  constructor(props) {
    super()
    this.props = props
  }

  render() {
    return (
      <div className="nomatch-wrapper">
        <h2 className="nomatch-header">Nah Fam</h2>       
      </div>  
    )
  }
}

export default noMatch;



/** WEBPACK FOOTER **
 ** ./src/js/views/noMatch/noMatch.js
 **/